import type { Selection } from '@/entities/searchCriteria';
import { getCountryResorts, getSearchFormData } from '@/shared/api';
import type { FormDataUrl } from '@/shared/config/formData';
import type { Country } from '@/shared/model';
import {
  EMIRATES_COUNTRY_ID,
  EMIRATES_DEFAULT_DEPARTURE_CITY_ID,
  isEmiratesDestination,
  type EmiratesDirectionSource,
} from '../lib/emiratesFilter';

interface EmiratesSearchSources {
  formUrl: FormDataUrl;
  resortsUrl?: string;
}

async function getEmiratesCountry(countries: readonly Country[], resortsUrl?: string): Promise<Country | null> {
  const country = countries.find(({ id }) => id === EMIRATES_COUNTRY_ID);

  if (!country) return null;

  const resorts = await getCountryResorts(country, resortsUrl);

  return { ...country, resorts };
}

export async function getEmiratesDirectionSource(
  destination: Selection | null,
  { formUrl, resortsUrl }: EmiratesSearchSources,
): Promise<EmiratesDirectionSource> {
  const formData = await getSearchFormData(formUrl);
  const city = formData.cities.find(({ id }) => id === EMIRATES_DEFAULT_DEPARTURE_CITY_ID) ?? null;
  const country = isEmiratesDestination(destination) ? null : await getEmiratesCountry(formData.countries, resortsUrl);

  return { country, city };
}
